import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { ThemeProvider } from 'react-jss'

import { COURSE_CUSTOM_CSS_OPTION_KEY } from 'constants/options.constants'

import DefaultPageNavigation from '../widgets/page-navigation/DefaultPageNavigation'
import SideNav from '../widgets/side-navigation/SideNav'
import Quiz from '../widgets/quiz/Quiz'
import Content from '../widgets/content/Content'
import ProductAssignmentSuccess from '../widgets/content/ProductAssignment/ProductAssignmentSuccess'
import Comments from '../widgets/comments/Comments'

@observer
class Default extends Component {
  componentDidMount() {
    const { courseViewsStore } = this.props
    courseViewsStore.setMembershipNavState(false)
  }

  componentDidUpdate() {
    const { courseViewsStore } = this.props
    courseViewsStore.setMembershipNavState(false)
  }

  componentWillUnmount() {
    const { courseViewsStore } = this.props
    courseViewsStore.setMembershipNavState(true)
    courseViewsStore?.resetActiveCommunity?.()
  }

  render() {
    const {
      courseViewsStore,
      preloadedContentPage,
      username,
      pathname,
      urlParams,
      queryParams,
      historyPush,
      historyGoBack,
      LinkComponent,
      commentsStore,
      sellerFontsStore,
      payerStore,
      sellerStore,
      sellablesStore,
      ordersStore,
      currenciesStore,
      contentPageStore,
      quizzesStore,
      lessonsStore,
      communitiesStore,
      communityMemberStore,
      sellersStore,
    } = this.props
    const {
      activeLesson: { active },
      courseThemeData: { prefs: themePrefs = {} },
      isAppActive,
      viewConfig: {
        widgets: { quiz: displayQuiz, success: displaySuccess, content: displayContent, comments: displayComments },
      },
    } = courseViewsStore
    const applyCustomCSS = themePrefs && themePrefs.css && isAppActive(COURSE_CUSTOM_CSS_OPTION_KEY)

    return (
      <div className='course-theme-default'>
        {applyCustomCSS && <style dangerouslySetInnerHTML={{ __html: `${themePrefs.css}` }} />}
        <DefaultPageNavigation
          cmpProps={this.props.cmpProps}
          historyGoBack={historyGoBack}
          pathname={pathname}
          currenciesStore={currenciesStore}
          courseViewsStore={courseViewsStore}
          contentPageStore={contentPageStore}
        />
        <ThemeProvider theme={{}}>
          <div className='course-preview'>
            <SideNav
              defaultTheme
              username={username}
              courseViewsStore={courseViewsStore}
              lessonsStore={lessonsStore}
              communitiesStore={communitiesStore}
              communityMemberStore={communityMemberStore}
              sellersStore={sellersStore}
            />
            <div className='lesson-page'>
              {displaySuccess && (
                <ProductAssignmentSuccess
                  ordersStore={ordersStore}
                  sellablesStore={sellablesStore}
                  courseViewsStore={courseViewsStore}
                />
              )}
              {active && displayQuiz && (
                <Quiz
                  defaultTheme
                  courseViewsStore={courseViewsStore}
                  quizzesStore={quizzesStore}
                  sellerFontsStore={sellerFontsStore}
                  payerStore={payerStore}
                />
              )}
              {displayContent && (
                <Content
                  preloadedContentPage={preloadedContentPage}
                  pathname={pathname}
                  urlParams={urlParams}
                  queryParams={queryParams}
                  historyPush={historyPush}
                  LinkComponent={LinkComponent}
                />
              )}
              {active && displayComments && (
                <Comments
                  courseViewsStore={courseViewsStore}
                  commentsStore={commentsStore}
                  sellerFontsStore={sellerFontsStore}
                  payerStore={payerStore}
                  sellerStore={sellerStore}
                />
              )}
            </div>
          </div>
        </ThemeProvider>
      </div>
    )
  }
}

Default.displayName = 'Default'

export default Default
